import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { 
  FEEDBACK_ON_DEMAND_STATUSES,
  getFeedbackStatusText,
  getFeedbackStatusColor,
  getFeedbackStatusTextColor,
  getFeedbackStatusBorderColor
} from '../../../constants/feedbackOnDemandStatuses';

const FeedbackOnDemandStatus = ({ 
  selectedStatuses = [], 
  onStatusToggle,
  statuses = null, // If null, shows all statuses. If array, shows only specified statuses
  sx = {} 
}) => {
  // Determine which statuses to show
  const statusesToShow = statuses || Object.values(FEEDBACK_ON_DEMAND_STATUSES);
  
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {statusesToShow.map((status) => {
        const statusText = getFeedbackStatusText(status);
        const isSelected = selectedStatuses.includes(status);
        
        return (
          <FilterChip
            key={status}
            label={statusText}
            isSelected={isSelected}
            onClick={() => onStatusToggle(status)}
            backgroundColor={getFeedbackStatusColor(status)}
            textColor={getFeedbackStatusTextColor(status)}
            borderColor={getFeedbackStatusBorderColor(status)}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default FeedbackOnDemandStatus; 